import {make_path,get_dirname} from './path_utils.js';
import {getFunctionsDir} from './function_dirs.js';
export function getSrcDir(): string {
    return get_dirname(getFunctionsDir());
};
export function geStaticDirectory():string{
    return make_path(getSrcDir(), 'static');
};
export function getLibUtilsDirectory():string{
    return make_path(getSrcDir(), 'lib');
}
export function getHooksUtilsDirectory():string{
    return make_path(getSrcDir(), 'hooks');
};
export function getFunctionsUtilsDirectory():string{
    return make_path(getSrcDir(), 'functions');
};
export function getComponentsUtilsDirectory():string{
    return make_path(getSrcDir(), 'components');
};